// Register.jsx  —  Route: /register
import React, { useState, useRef, useEffect } from "react"
import MetaTags from "react-meta-tags"
import Logo from "../../assets/images/companylogo1.png"
import NameLogo from "../../assets/images/companynamelogo1.png"
const BgLandscape =
  "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Mindex%20Clinical%20Spectrum%2FLogin%20Page%20-%201920x1080.png?alt=media&token=fd0c3d08-038d-49b4-afc8-859fb6f1fa43"
const BgPortrait =
  "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Mindex%20Clinical%20Spectrum%2FLogin%20Page%20-%201080x1920.png?alt=media&token=50a6fb45-886b-4853-a24e-565472642f4a"

// ─── Data ─────────────────────────────────────────────────────────────────────
const STATE_CITIES = {
  "Andhra Pradesh": [
    "Visakhapatnam",
    "Vijayawada",
    "Guntur",
    "Nellore",
    "Kurnool",
  ],
  "Arunachal Pradesh": ["Itanagar", "Naharlagun", "Pasighat"],
  Assam: ["Guwahati", "Silchar", "Dibrugarh", "Jorhat", "Nagaon"],
  Bihar: ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Darbhanga"],
  Chhattisgarh: ["Raipur", "Bhilai", "Bilaspur", "Korba", "Durg"],
  Goa: ["Panaji", "Margao", "Vasco da Gama", "Mapusa"],
  Gujarat: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar"],
  Haryana: ["Gurugram", "Faridabad", "Panipat", "Ambala", "Hisar"],
  "Himachal Pradesh": ["Shimla", "Manali", "Dharamshala", "Solan", "Mandi"],
  Jharkhand: ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Deoghar"],
  Karnataka: ["Bengaluru", "Mysuru", "Mangaluru", "Hubballi", "Belagavi"],
  Kerala: ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam"],
  "Madhya Pradesh": ["Bhopal", "Indore", "Jabalpur", "Gwalior", "Ujjain"],
  Maharashtra: ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad", "Thane"],
  Manipur: ["Imphal", "Thoubal", "Bishnupur"],
  Meghalaya: ["Shillong", "Tura", "Jowai"],
  Mizoram: ["Aizawl", "Lunglei", "Saiha"],
  Nagaland: ["Kohima", "Dimapur", "Mokokchung"],
  Odisha: ["Bhubaneswar", "Cuttack", "Rourkela", "Berhampur", "Sambalpur"],
  Punjab: ["Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda"],
  Rajasthan: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer"],
  Sikkim: ["Gangtok", "Namchi", "Pelling"],
  "Tamil Nadu": [
    "Chennai",
    "Coimbatore",
    "Madurai",
    "Tiruchirappalli",
    "Salem",
  ],
  Telangana: ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Ramagundam"],
  Tripura: ["Agartala", "Udaipur", "Dharmanagar"],
  "Uttar Pradesh": [
    "Lucknow",
    "Kanpur",
    "Varanasi",
    "Agra",
    "Meerut",
    "Prayagraj",
  ],
  Uttarakhand: ["Dehradun", "Haridwar", "Roorkee", "Haldwani", "Nainital"],
  "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Asansol", "Siliguri"],
  Delhi: [
    "New Delhi",
    "North Delhi",
    "South Delhi",
    "East Delhi",
    "West Delhi",
  ],
  Chandigarh: ["Chandigarh"],
  "Jammu & Kashmir": ["Srinagar", "Jammu", "Anantnag", "Sopore"],
  Ladakh: ["Leh", "Kargil"],
  Puducherry: ["Puducherry", "Karaikal", "Mahe", "Yanam"],
}

// ─── Field wrapper — outside component to prevent unmount-on-keystroke bug ────
const Field = ({ name, label, errors, children }) => (
  <div className={`fg${errors[name] ? " has-error" : ""}`}>
    {label && <label className="fl">{label}</label>}
    {children}
    {errors[name] && <span className="invalid-feedback">{errors[name]}</span>}
  </div>
)

// ─── Particles — stable reference outside component ───────────────────────────
const PARTICLES = Array.from({ length: 22 }, (_, i) => ({
  id: i,
  size: Math.random() * 6 + 3,
  left: Math.random() * 100,
  delay: Math.random() * 20,
  dur: Math.random() * 13 + 11,
}))

function Particles() {
  return (
    <div className="particles">
      {PARTICLES.map(p => (
        <div
          key={p.id}
          className="particle"
          style={{
            width: p.size,
            height: p.size,
            left: `${p.left}%`,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.dur}s`,
          }}
        />
      ))}
    </div>
  )
}

// ─── Terms & Conditions Modal ─────────────────────────────────────────────────
function TnCModal({ onClose }) {
  return (
    <div className="po tnc-overlay" onClick={onClose}>
      <div className="tnc-box" onClick={e => e.stopPropagation()}>
        {/* Top bar */}
        <div className="tnc-header">
          <span className="tnc-title">Terms &amp; Conditions</span>
          <button className="tnc-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>
        <div className="tnc-body">
          <p>
            I hereby voluntarily provide my consent to <strong>Danone</strong>{" "}
            and its authorized third party partners:
          </p>
          <ol>
            <li>
              To collect, use, process and store my sensitive personal data and
              information in accordance with applicable law.
            </li>
            <li>
              To have access to my sensitive personal data and information in
              accordance with applicable law.
            </li>
          </ol>
          <p>
            I understand and I consent to Danone and its authorized third party
            partners sending me updates and important information from time to
            time by way of <strong>WhatsApp, SMS and/or email</strong>.
          </p>
          <p className="tnc-withdraw">
            I understand that I can withdraw my consent at any time by
            contacting Danone.
          </p>
        </div>
        <div className="tnc-footer">
          <button className="tnc-btn" onClick={onClose}>
            I Understand
          </button>
        </div>
      </div>
    </div>
  )
}

// ─── Success / Error Popup ────────────────────────────────────────────────────
function Popup({ type, title, message, dateNote, onClose }) {
  return (
    <div className="po" onClick={onClose}>
      <div className={`pb ${type}`} onClick={e => e.stopPropagation()}>
        <div className={`piw ${type}`}>{type === "success" ? "✓" : "✕"}</div>
        <div className="pt">{title}</div>
        <div className="pm">{message}</div>
        {dateNote && <div className="pm-date">{dateNote}</div>}
        <button className={`pc ${type}`} onClick={onClose}>
          {type === "success" ? "Got it!" : "Try Again"}
        </button>
      </div>
    </div>
  )
}

// ─── Validation ───────────────────────────────────────────────────────────────
function validate({ fullname, email, state, city, phone, otherCity }) {
  const errs = {}
  if (!fullname.trim()) errs.fullname = "Full name is required"
  if (!email.trim()) errs.email = "Email is required"
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
    errs.email = "Enter a valid email"
  if (!state) errs.state = "Please select a state"
  if (!city) errs.city = "Please select a city"
  else if (city === "Other" && !otherCity.trim())
    errs.city = "Please specify your city"
  if (!phone.trim()) errs.phone = "Phone number is required"
  else if (!/^[0-9]{10}$/.test(phone.trim()))
    errs.phone = "Enter a valid 10-digit number"
  return errs
}

// ─── Styles ───────────────────────────────────────────────────────────────────
const css = `
/* ── Local fonts ── */
@font-face {
  font-family: 'Acumin';
  src: url('/assets/fonts/AcuminVariableConcept.otf') format('opentype');
  font-weight: 100 900;
  font-style: normal;
}
@font-face {
  font-family: 'MyriadPro';
  src: url('/assets/fonts/MyriadPro-Regular.otf') format('opentype');
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: 'Inter';
  src: url('/assets/fonts/Inter_18pt-Thin.ttf') format('truetype');
  font-weight: 100;
}
@font-face {
  font-family: 'Inter';
  src: url('/assets/fonts/Inter_18pt-Light.ttf') format('truetype');
  font-weight: 300;
}
@font-face {
  font-family: 'Inter';
  src: url('/assets/fonts/Inter_18pt-Regular.ttf') format('truetype');
  font-weight: 400;
}
@font-face {
  font-family: 'Inter';
  src: url('/assets/fonts/Inter_18pt-Bold.ttf') format('truetype');
  font-weight: 700;
}

:root {
  --navy:    #2D3991;
  --mid:     #3255CC;
  --sky:     #4fc1b0;
  --sky-lt:  #C8E9F8;
  --text:    #1A1F4B;
  --muted:   #6B7AAD;
  --error:   #E8395A;
  --success: #27AE8F;
  --font-display: 'Acumin', 'Inter', sans-serif;
  --font-body:    'Inter', 'MyriadPro', sans-serif;
}

*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
html,body{height:100%;overflow-x:hidden;font-family:var(--font-body)}

/* ── BG — static image, landscape by default, portrait on mobile ── */
.bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  /* Landscape background image (desktop) */
  background-image: url(${BgLandscape});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  overflow: hidden;
}

/* Portrait background image on mobile / narrow viewports */
@media (max-width: 920px) {
  .bg {
    background-image: url(${BgPortrait});
  }
}

/* ── Commented-out animated background elements ──
.blob{position:absolute;border-radius:50%;filter:blur(65px);pointer-events:none;mix-blend-mode:multiply}
.b1{width:720px;height:720px;background:radial-gradient(circle,rgba(137,207,240,.6) 0%,transparent 70%);top:-200px;left:-160px;animation:bm1 15s ease-in-out infinite alternate}
.b2{width:520px;height:520px;background:radial-gradient(circle,rgba(50,85,204,.22) 0%,transparent 65%);bottom:-120px;right:-80px;animation:bm2 19s ease-in-out infinite alternate}
.b3{width:380px;height:380px;background:radial-gradient(circle,rgba(45,57,145,.16) 0%,transparent 70%);top:38%;left:48%;animation:bm3 11s ease-in-out infinite alternate}
.b4{width:260px;height:260px;background:radial-gradient(circle,rgba(137,207,240,.45) 0%,transparent 70%);bottom:18%;left:4%;animation:bm4 13s ease-in-out infinite alternate}
@keyframes bm1{0%{transform:translate(0,0) scale(1) rotate(0deg)}33%{transform:translate(90px,-70px) scale(1.18) rotate(35deg)}66%{transform:translate(-50px,90px) scale(.88) rotate(-18deg)}100%{transform:translate(65px,45px) scale(1.12) rotate(22deg)}}
@keyframes bm2{0%{transform:translate(0,0) scale(1)}50%{transform:translate(-90px,-55px) scale(1.22)}100%{transform:translate(45px,90px) scale(.82)}}
@keyframes bm3{0%{transform:translate(-50%,-50%) scale(1)}100%{transform:translate(-50%,-50%) scale(1.5) rotate(180deg)}}
@keyframes bm4{0%{transform:translate(0,0) scale(1)}100%{transform:translate(50px,-90px) scale(1.35)}}
.bg-grid{position:absolute;inset:0;background-image:linear-gradient(rgba(45,57,145,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(45,57,145,.04) 1px,transparent 1px);background-size:52px 52px;animation:gp 35s linear infinite}
@keyframes gp{0%{background-position:0 0}100%{background-position:52px 52px}}
.bg-grain{position:absolute;inset:0;opacity:.022;pointer-events:none;background-image:url("data:image/svg+xml,...");background-size:200px 200px;animation:gr .15s steps(1) infinite}
@keyframes gr{0%{background-position:0 0}25%{background-position:-28px 14px}50%{background-position:12px -18px}75%{background-position:22px 8px}}
── end commented-out BG ── */

.particles{position:absolute;inset:0;pointer-events:none}
.particle{position:absolute;border-radius:50%;background:var(--sky);animation:pf linear infinite;opacity:0}
@keyframes pf{0%{transform:translateY(100vh) scale(0);opacity:0}10%{opacity:.55}90%{opacity:.25}100%{transform:translateY(-10vh) scale(1.6);opacity:0}}
.rings{position:absolute;right:7%;top:50%;transform:translateY(-50%);pointer-events:none}
.ring{position:absolute;border-radius:50%;top:50%;left:50%;transform:translate(-50%,-50%);animation:rp ease-out infinite}
.r1{width:140px;height:140px;border:1.5px solid rgba(137,207,240,.55);animation-duration:3.2s;animation-delay:0s}
.r2{width:240px;height:240px;border:1.5px solid rgba(50,85,204,.32);animation-duration:3.2s;animation-delay:.7s}
.r3{width:340px;height:340px;border:1px solid rgba(45,57,145,.18);animation-duration:3.2s;animation-delay:1.4s}
.r4{width:440px;height:440px;border:1px solid rgba(137,207,240,.12);animation-duration:3.2s;animation-delay:2.1s}
.r5{width:540px;height:540px;border:1px solid rgba(50,85,204,.07);animation-duration:3.2s;animation-delay:2.8s}
@keyframes rp{0%{transform:translate(-50%,-50%) scale(.3);opacity:.9}60%{transform:translate(-50%,-50%) scale(3);opacity:0.3}100%{transform:translate(-50%,-50%) scale(3);opacity:0.1}}

/* ── LAYOUT ── */
.pw{position:relative;z-index:1;min-height:100vh;display:grid;grid-template-columns:1fr 1fr;align-items:stretch;gap:0}

/* ── LEFT ── */
.lp{display:flex;flex-direction:column;justify-content:center;align-items:center;padding:48px 24px 48px 100px;position:relative}
.deco-logo{position:absolute;right:-30%;opacity:.2;pointer-events:none;animation:ds 50s linear infinite}
.deco-logo img{width:380px}
@keyframes ds{from{transform:rotate(0)}to{transform:rotate(360deg)}}
.a1{opacity:0;animation:su .85s .15s cubic-bezier(.22,1,.36,1) forwards}
.a2{opacity:0;animation:su .85s .35s cubic-bezier(.22,1,.36,1) forwards}
@keyframes su{from{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}
.logo-img{height:180px;object-fit:contain}
.date-pill{margin-top:32px;display:inline-flex;align-items:center;gap:10px;position:relative}
.date-text{font-family:var(--font-display);font-size:1.1rem;font-weight:600;letter-spacing:.04em;background:linear-gradient(110deg,var(--navy) 0%,var(--mid) 50%,var(--sky) 100%);background-size:220% 100%;-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;animation:gs 4s ease infinite alternate}
@keyframes gs{0%{background-position:0% 50%}100%{background-position:100% 50%}}
.date-pill::after{content:'';position:absolute;bottom:-6px;left:0;right:0;height:2px;background:linear-gradient(90deg,var(--sky),var(--mid),var(--navy),var(--mid),var(--sky));background-size:200% 100%;border-radius:2px;animation:tb 2.5s linear infinite;box-shadow:0 0 8px rgba(50,85,204,.45)}
@keyframes tb{0%{background-position:0%}100%{background-position:200%}}
.date-dot{width:8px;height:8px;border-radius:50%;flex-shrink:0;background:var(--mid);animation:dp 1.8s ease-in-out infinite}
@keyframes dp{0%{box-shadow:0 0 0 0 rgba(50,85,204,.5)}60%{box-shadow:0 0 0 7px rgba(50,85,204,0)}100%{box-shadow:0 0 0 0 rgba(50,85,204,0)}}

/* ── RIGHT / FORM CARD ── */
.rp{display:flex;align-items:center;justify-content:center;padding:28px 32px 28px 0}
.fc{width:100%;max-width:460px;background:rgba(255,255,255,.78);backdrop-filter:blur(32px) saturate(1.5);border:1px solid rgba(137,207,240,.45);border-radius:28px;padding:32px 34px 26px;box-shadow:0 2px 1px rgba(255,255,255,.95) inset,0 28px 90px rgba(45,57,145,.13),0 4px 18px rgba(137,207,240,.22);opacity:0;animation:ci .9s .45s cubic-bezier(.22,1,.36,1) forwards;position:relative;overflow:hidden}
.fc::before{content:'';position:absolute;top:0;left:-100%;width:50%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.38),transparent);animation:sw 3s 1.3s ease forwards;pointer-events:none}
@keyframes sw{0%{left:-100%}100%{left:210%}}
.fc::after{content:'';position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,var(--sky),var(--mid),var(--navy),var(--mid),var(--sky));background-size:200% 100%;animation:tb 2.8s linear infinite}
@keyframes ci{from{opacity:0;transform:translateX(44px) scale(.96)}to{opacity:1;transform:translateX(0) scale(1)}}

.ct{font-family:var(--font-display);font-size:1.4rem;font-weight:700;color:var(--text);text-align:center;margin-bottom:3px;letter-spacing:-.01em}
.cs{font-size:.82rem;color:var(--muted);font-weight:300;text-align:center;margin-bottom:20px}

/* ── FIELDS ── */
.fg{margin-bottom:12px;position:relative}
.fl{display:block;font-size:.7rem;font-weight:500;color:var(--muted);letter-spacing:.1em;text-transform:uppercase;margin-bottom:5px;font-family:var(--font-body)}

.fg input,
.fg select {
  width:100%;padding:6px 14px;
  border:1.5px solid rgba(45,57,145,.13);
  border-radius:13px;
  background:rgba(240,244,255,.55);
  color:var(--text);
  font-family:var(--font-body);font-size:.9rem;
  outline:none;
  transition:border-color .25s,background .25s,box-shadow .25s,transform .18s;
  appearance:none;
}
.fg input:focus,
.fg select:focus {
  border-color:var(--mid);
  background:rgba(255,255,255,.97);
  box-shadow:0 0 0 4px rgba(50,85,204,.09),0 2px 14px rgba(50,85,204,.07);
  transform:translateY(-1px);
}
.fg input::placeholder{color:#B4BCDA}
.fg select:disabled{opacity:.5;cursor:not-allowed}
.fg.has-error input,.fg.has-error select{border-color:var(--error);background:rgba(232,57,90,.04)}
.invalid-feedback{font-size:.72rem;color:var(--error);margin-top:3px;display:block;font-family:var(--font-body)}

.sel-wrap{position:relative}
.sel-wrap::after{content:'▾';position:absolute;right:12px;top:50%;transform:translateY(-50%);font-size:.75rem;color:var(--muted);pointer-events:none}
.sel-wrap select{padding-right:32px;cursor:pointer;width:100%}

/* Other city text input */
.other-city-wrap {
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  transform: translateY(-6px);
  transition: max-height .3s ease, opacity .3s ease, transform .3s ease;
  margin-top: 0;
}
.other-city-wrap.visible {
  max-height: 60px;
  opacity: 1;
  transform: translateY(0);
  margin-top: 8px;
}
.other-city-wrap input {
  width: 100%; padding: 6px 14px;
  border: 1.5px solid rgba(45,57,145,.13);
  border-radius: 13px;
  background: rgba(240,244,255,.55);
  color: var(--text);
  font-family: var(--font-body); font-size: .9rem;
  outline: none;
  transition: border-color .25s, background .25s, box-shadow .25s;
  appearance: none;
}
.other-city-wrap input:focus {
  border-color: var(--mid);
  background: rgba(255,255,255,.97);
  box-shadow: 0 0 0 4px rgba(50,85,204,.09);
}
.other-city-wrap input::placeholder { color: #B4BCDA; }

.phone-row{display:grid;grid-template-columns:52px 1fr;gap:8px}
.phone-prefix{display:flex;align-items:center;justify-content:center;background:rgba(50,85,204,.08);border:1.5px solid rgba(45,57,145,.13);border-radius:13px;font-size:.88rem;font-weight:600;color:var(--navy);letter-spacing:.02em;font-family:var(--font-body)}

/* ── TERMS CHECKBOX ── */
.tnc-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 14px 0 10px;
  padding: 12px 14px;
  border-radius: 13px;
  background: rgba(50,85,204,.05);
  border: 1.5px solid rgba(50,85,204,.1);
  transition: border-color .25s, background .25s;
}
.tnc-row.checked {
  background: rgba(50,85,204,.08);
  border-color: rgba(50,85,204,.25);
}

/* custom checkbox */
.tnc-check {
  position: relative;
  flex-shrink: 0;
  width: 18px; height: 18px;
  margin-top: 1px;
}
.tnc-check input[type="checkbox"] {
  position: absolute; opacity: 0; width: 18px; height: 18px;
  margin: 0; cursor: pointer; z-index: 1;
}
.tnc-check-box {
  width: 18px; height: 18px;
  border: 2px solid rgba(50,85,204,.35);
  border-radius: 5px;
  background: white;
  display: flex; align-items: center; justify-content: center;
  transition: background .2s, border-color .2s, transform .15s;
  pointer-events: none;
}
.tnc-check input:checked ~ .tnc-check-box {
  background: linear-gradient(135deg, var(--navy), var(--mid));
  border-color: var(--mid);
  transform: scale(1.08);
}
.tnc-check-box svg {
  opacity: 0; transform: scale(0);
  transition: opacity .18s, transform .18s;
}
.tnc-check input:checked ~ .tnc-check-box svg {
  opacity: 1; transform: scale(1);
}

.tnc-label {
  font-size: .78rem;
  color: var(--muted);
  line-height: 1.55;
  font-family: var(--font-body);
}
.tnc-label .tnc-link {
  color: var(--mid);
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
  transition: color .15s;
  background: none; border: none; padding: 0;
  font-family: var(--font-body); font-size: inherit;
}
.tnc-label .tnc-link:hover { color: var(--navy); }

/* ── BUTTON ── */
.sbtn{width:100%;padding:14px;margin-top:6px;border:none;border-radius:50px;cursor:pointer;font-family:var(--font-display);font-size:.98rem;font-weight:700;letter-spacing:.04em;color:white;background:linear-gradient(to right, var(--navy) 0%, var(--sky) 55%);background-size:200% 100%;position:relative;overflow:hidden;transition:transform .2s,box-shadow .2s,background-position .45s,opacity .2s;box-shadow:0 6px 26px rgba(50,85,204,.42)}
.sbtn:hover:not(:disabled){transform:translateY(-3px) scale(1.01);box-shadow:0 14px 40px rgba(50,85,204,.52);background-position:100% 0%}
.sbtn:active:not(:disabled){transform:translateY(-1px) scale(.99)}
.sbtn:disabled{opacity:.38;cursor:not-allowed;box-shadow:none;transform:none}
.sbtn::before{content:'';position:absolute;top:0;left:-80%;width:50%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.22),transparent);transform:skewX(-15deg)}
.sbtn:hover:not(:disabled)::before{animation:bsh .5s ease forwards}
@keyframes bsh{0%{left:-80%}100%{left:155%}}
.arr{display:inline-block;margin-left:8px;animation:ab 1.6s ease-in-out infinite}
@keyframes ab{0%,100%{transform:translateX(0)}50%{transform:translateX(5px)}}
.spin{display:inline-block;width:14px;height:14px;border:2px solid rgba(255,255,255,.4);border-top-color:white;border-radius:50%;animation:spn .7s linear infinite;margin-left:10px;vertical-align:middle}
@keyframes spn{to{transform:rotate(360deg)}}
.fn{margin-top:12px;text-align:center;font-size:.72rem;color:var(--muted);line-height:1.65;opacity:.8;font-family:var(--font-body)}

/* ── POPUP (success / error) ── */
.po{position:fixed;inset:0;z-index:9999;background:rgba(8,12,44,.52);backdrop-filter:blur(12px);display:flex;align-items:center;justify-content:center;animation:foi .22s ease}
@keyframes foi{from{opacity:0}to{opacity:1}}
.pb{background:white;border-radius:28px;padding:44px 38px;max-width:420px;width:88%;text-align:center;box-shadow:0 36px 110px rgba(45,57,145,.24);animation:pbi .42s cubic-bezier(.22,1,.36,1);position:relative;overflow:hidden}
.pb::before{content:'';position:absolute;top:0;left:0;right:0;height:4px}
.pb.success::before{background:linear-gradient(90deg,var(--sky),var(--mid),var(--navy))}
.pb.error::before{background:linear-gradient(90deg,var(--error),#FF6B8A)}
@keyframes pbi{from{opacity:0;transform:scale(.8) translateY(28px)}to{opacity:1;transform:scale(1) translateY(0)}}
.piw{width:72px;height:72px;border-radius:50%;margin:0 auto 18px;display:flex;align-items:center;justify-content:center;font-size:30px;position:relative;animation:ib .55s .28s cubic-bezier(.22,1,.36,1) both}
@keyframes ib{0%{transform:scale(0)}65%{transform:scale(1.18)}100%{transform:scale(1)}}
.piw::before,.piw::after{content:'';position:absolute;inset:0;border-radius:50%;animation:ir 2.2s ease-out infinite}
.piw::after{animation-delay:.8s}
.piw.success{background:rgba(50,85,204,.1)}
.piw.success::before,.piw.success::after{border:2px solid rgba(50,85,204,.25)}
.piw.error{background:rgba(232,57,90,.1)}
.piw.error::before,.piw.error::after{border:2px solid rgba(232,57,90,.3)}
@keyframes ir{0%{transform:scale(1);opacity:.8}100%{transform:scale(2.4);opacity:0}}
.pt{font-family:var(--font-display);font-size:1.32rem;font-weight:700;color:var(--text);margin-bottom:8px}
.pm{font-size:.88rem;color:var(--muted);line-height:1.65;margin-bottom:10px;font-family:var(--font-body)}
.pm-date{
  font-family:var(--font-display);font-size:1rem;font-weight:700;
  background:linear-gradient(110deg,var(--navy) 0%,var(--mid) 50%,var(--sky) 100%);
  background-size:220% 100%;
  -webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;
  animation:gs 4s ease infinite alternate;
  margin-bottom:22px;display:inline-block;
}
.pc{padding:12px 36px;border:none;border-radius:50px;cursor:pointer;font-family:var(--font-display);font-size:.93rem;font-weight:700;color:white;transition:transform .2s,box-shadow .2s}
.pc.success{background:linear-gradient(to right,var(--navy) 0%,var(--sky) 55%);box-shadow:0 6px 24px rgba(50,85,204,.42)}
.pc.error{background:linear-gradient(to right,var(--navy),var(--sky) 55%);box-shadow:0 6px 20px rgba(50,85,204,.38)}
.pc:hover{transform:translateY(-2px)}

/* ── TERMS MODAL ── */
.tnc-overlay{ align-items: flex-end; }
@media(min-width:481px){ .tnc-overlay{ align-items: center; } }

.tnc-box{
  background: white;
  border-radius: 24px;
  width: 88%; max-width: 500px;
  max-height: 82vh;
  display: flex; flex-direction: column;
  box-shadow: 0 32px 100px rgba(45,57,145,.22);
  animation: pbi .38s cubic-bezier(.22,1,.36,1);
  overflow: hidden;
}
.tnc-header{
  display: flex; align-items: center; justify-content: space-between;
  padding: 20px 28px 16px;
  border-bottom: 1px solid rgba(45,57,145,.08);
  position: relative;
}
.tnc-header::after{
  content:'';position:absolute;bottom:0;left:0;right:0;height:3px;
  background:linear-gradient(90deg,var(--sky),var(--mid),var(--navy),var(--mid),var(--sky));
  background-size:200% 100%;animation:tb 2.8s linear infinite;
}
.tnc-title{font-family:var(--font-display);font-size:1.1rem;font-weight:700;color:var(--text)}
.tnc-close{
  background:rgba(45,57,145,.07);border:none;cursor:pointer;
  width:32px;height:32px;border-radius:50%;
  display:flex;align-items:center;justify-content:center;
  font-size:.85rem;color:var(--muted);
  transition:background .2s,color .2s;
}
.tnc-close:hover{background:rgba(232,57,90,.1);color:var(--error)}

.tnc-body{
  overflow-y:auto;padding:24px 28px;
  font-family:var(--font-body);font-size:.88rem;color:var(--muted);line-height:1.75;
  display:flex;flex-direction:column;gap:14px;
  flex:1;
}
.tnc-body p strong{color:var(--navy)}
.tnc-body ol{padding-left:20px;display:flex;flex-direction:column;gap:10px}
.tnc-body ol li{color:var(--text)}
.tnc-withdraw{
  font-size:.82rem;color:var(--muted);
  padding:10px 14px;
  background:rgba(50,85,204,.05);
  border-left:3px solid var(--mid);
  border-radius:0 8px 8px 0;
}

.tnc-footer{
  padding:16px 28px 20px;
  border-top:1px solid rgba(45,57,145,.08);
}
.tnc-btn{
  width:100%;padding:12px;border:none;border-radius:13px;
  cursor:pointer;font-family:var(--font-display);font-size:.95rem;font-weight:700;
  color:white;
  background:linear-gradient(120deg,var(--navy) 0%,var(--mid) 55%,#4B70EE 100%);
  box-shadow:0 4px 18px rgba(50,85,204,.38);
  transition:transform .18s,box-shadow .18s;
}
.tnc-btn:hover{transform:translateY(-2px);box-shadow:0 8px 24px rgba(50,85,204,.46)}

/* ── RESPONSIVE ── */
@media(max-width:920px){
  .pw{grid-template-columns:1fr}
  .lp{padding:36px 24px 24px;align-items:center;text-align:center}
  .date-pill{justify-content:center}
  .rings,.deco-logo{display:none}
  .rp{padding:16px 18px 44px}
}
@media(max-width:480px){
  .logo-img{height:110px}
  .fc{padding:26px 18px 20px}
}
`

// ─── Main component ───────────────────────────────────────────────────────────
const Regiister = () => {
  const [fullname, setFullname] = useState("")
  const [email, setEmail] = useState("")
  const [state, setState] = useState("")
  const [city, setCity] = useState("")
  const [phone, setPhone] = useState("")
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [popup, setPopup] = useState(null)
  const [tncChecked, setTncChecked] = useState(false)
  const [tncOpen, setTncOpen] = useState(false)
  const [otherCity, setOtherCity] = useState("")

  const cities = state ? STATE_CITIES[state] || [] : []

  useEffect(() => {
    setCity("")
    setOtherCity("")
  }, [state])
  useEffect(() => {
    document.querySelector(".loader")?.classList.add("loader--hide")
  }, [])

  const handleSubmit = async e => {
    e.preventDefault()
    const errs = validate({ fullname, email, state, city, phone, otherCity })
    if (Object.keys(errs).length) {
      setErrors(errs)
      return
    }
    setErrors({})
    setLoading(true)

    const registrationDate = new Date().toLocaleString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })

    try {
      const res = await fetch(
        process.env.REACT_APP_ADMIN + "/api/mindex-register",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            Fullname: fullname.trim(),
            Email: email.trim(),
            State: state,
            City: city === "Other" ? otherCity.trim() || "Other" : city,
            Phone: phone.trim(),
            RegistrationDate: registrationDate,
          }),
        }
      )
      const data = await res.json()

      if (res.ok && data.success) {
        setPopup({
          type: "success",
          title: "Thank you for Registering! 🎉",
          message: `We look forward to seeing you!`,
          dateNote: "27th March · 7:00 PM Onwards",
        })
        setFullname("")
        setEmail("")
        setState("")
        setCity("")
        setPhone("")
        setOtherCity("")
        setTncChecked(false)
      } else {
        setPopup({
          type: "error",
          title: "Registration Failed",
          message: data.mssg || "Something went wrong. Please try again.",
          dateNote: null,
        })
      }
    } catch {
      setPopup({
        type: "error",
        title: "Network Error",
        message: "Could not reach the server. Please check your connection.",
        dateNote: null,
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <MetaTags>
        <title>Mindex Clinical Spectrum 2026</title>
      </MetaTags>
      <style>{css}</style>

      {/* Background — static image (landscape on desktop, portrait on mobile) */}
      {/* Animated blobs, grid, grain and particles are commented out below    */}
      <div className="bg">
        {/*
        <div className="bg-grid" />
        <div className="blob b1" /><div className="blob b2" />
        <div className="blob b3" /><div className="blob b4" />
        <Particles />
        <div className="bg-grain" />
        */}
      </div>

      {/* Terms modal */}
      {tncOpen && <TnCModal onClose={() => setTncOpen(false)} />}

      {/* Success / error popup */}
      {popup && <Popup {...popup} onClose={() => setPopup(null)} />}

      <div className="pw">
        {/* LEFT */}
        <div className="lp">
          <div className="deco-logo" aria-hidden="true">
            <img src={Logo} alt="" />
          </div>
          <div className="rings">
            <div className="ring r1" />
            <div className="ring r2" />
            <div className="ring r3" />
            <div className="ring r4" />
            <div className="ring r5" />
          </div>
          <div className="a1">
            <img
              className="logo-img"
              src={NameLogo}
              alt="Mindex Clinical Spectrum"
            />
          </div>
          <div className="a2">
            <div className="date-pill">
              <span className="date-dot" />
              <span className="date-text">
                27th March &nbsp;·&nbsp; 7PM Onwards
              </span>
            </div>
          </div>
        </div>

        {/* RIGHT — FORM */}
        <div className="rp">
          <div className="fc">
            <div className="ct">Registration</div>
            <br />
            {/* <div className="cs">Fill in your details to claim your spot</div> */}

            <form onSubmit={handleSubmit} noValidate>
              <Field name="fullname" label="Full Name" errors={errors}>
                <input
                  type="text"
                  placeholder="Enter your full name*"
                  value={fullname}
                  onChange={e => setFullname(e.target.value)}
                />
              </Field>

              <Field name="email" label="Email ID" errors={errors}>
                <input
                  type="email"
                  placeholder="Email Id*"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </Field>

              <Field name="state" label="State" errors={errors}>
                <div className="sel-wrap">
                  <select
                    value={state}
                    onChange={e => setState(e.target.value)}
                  >
                    <option value="">Select a state*</option>
                    {Object.keys(STATE_CITIES)
                      .sort()
                      .map(s => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                  </select>
                </div>
              </Field>

              <Field name="city" label="City" errors={errors}>
                <div className="sel-wrap">
                  <select
                    value={city}
                    onChange={e => setCity(e.target.value)}
                    disabled={!state}
                  >
                    <option value="">Select a city*</option>
                    {cities.map(c => (
                      <option key={c} value={c}>
                        {c}
                      </option>
                    ))}
                    {state && <option value="Other">Other</option>}
                  </select>
                </div>
                <div
                  className={`other-city-wrap${
                    city === "Other" ? " visible" : ""
                  }`}
                >
                  <input
                    type="text"
                    placeholder="Please specify your city*"
                    value={otherCity}
                    onChange={e => setOtherCity(e.target.value)}
                  />
                </div>
              </Field>

              <Field name="phone" label="Contact Number" errors={errors}>
                <div className="phone-row">
                  <div className="phone-prefix">+91</div>
                  <input
                    type="tel"
                    placeholder="10-digit number*"
                    value={phone}
                    onChange={e =>
                      setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))
                    }
                    maxLength={10}
                  />
                </div>
              </Field>

              {/* ── Terms & Conditions checkbox ── */}
              <div className={`tnc-row${tncChecked ? " checked" : ""}`}>
                <label className="tnc-check">
                  <input
                    type="checkbox"
                    checked={tncChecked}
                    onChange={e => setTncChecked(e.target.checked)}
                  />
                  <span className="tnc-check-box">
                    <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                      <path
                        d="M1 4L3.5 6.5L9 1"
                        stroke="white"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </label>
                <span className="tnc-label">
                  I agree to the{" "}
                  <button
                    type="button"
                    className="tnc-link"
                    onClick={() => setTncOpen(true)}
                  >
                    Terms &amp; Conditions
                  </button>
                </span>
              </div>

              <button
                className="sbtn"
                type="submit"
                disabled={loading || !tncChecked}
              >
                {loading ? (
                  <span>
                    Registering
                    <span className="spin" />
                  </span>
                ) : (
                  <span>
                    Submit <span className="arr">→</span>
                  </span>
                )}
              </button>
            </form>

            <p className="fn">* Please use your official ID to register</p>
          </div>
        </div>
      </div>
    </>
  )
}

export default Regiister
